import React from 'react';
import ReactFlow, { 
  Background, 
  Controls, 
  MiniMap,
  Handle,
  Position,
  MarkerType
} from 'reactflow';
import 'reactflow/dist/style.css';

const EvoMLIntellectualProperty = () => {
  const nodes = [
    {
      id: '1',
      type: 'input',
      data: { 
        label: (
          <div style={{ padding: '15px', textAlign: 'center' }}>
            <strong style={{ fontSize: '18px' }}>🔬 EvoML Platform</strong>
            <div style={{ fontSize: '14px', marginTop: '8px', color: '#1976D2' }}>
              Intellectual Property Protection Framework
            </div>
            <div style={{ fontSize: '12px', marginTop: '5px', color: '#666' }}>
              Safeguarding ML Innovation & Technology
            </div>
          </div>
        )
      },
      position: { x: 400, y: 0 },
      style: {
        background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
        border: '3px solid #1976D2',
        borderRadius: '12px',
        width: 350,
        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
      }
    },
    
    // Core Technology Protection
    {
      id: 'core-tech',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>🎯 Core Technology Assets</strong>
          </div>
        )
      },
      position: { x: 375, y: 140 },
      style: {
        background: '#f5f5f5',
        border: '2px solid #2196F3',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Algorithm Protection
    {
      id: 'algorithms',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#1565C0' }}>🧮 Proprietary Algorithms</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Evolutionary optimization methods</li>
              <li>Adaptive hyperparameter tuning</li>
              <li>Custom feature engineering pipeline</li>
              <li>Model selection heuristics</li>
              <li>Ensemble generation strategies</li>
              <li>Performance prediction models</li>
            </ul>
          </div>
        )
      },
      position: { x: 50, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #64B5F6',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // ML Models Protection
    {
      id: 'ml-models',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#1565C0' }}>🤖 ML Model Assets</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Pre-trained model architectures</li>
              <li>Custom loss functions</li>
              <li>Model compression techniques</li>
              <li>Transfer learning adaptations</li>
              <li>Domain-specific models</li>
              <li>Model versioning system</li>
            </ul>
          </div>
        )
      },
      position: { x: 360, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #64B5F6',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Data & Pipeline Protection
    {
      id: 'data-pipeline',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#1565C0' }}>📊 Data & Pipeline IP</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Data preprocessing workflows</li>
              <li>Feature extraction methods</li>
              <li>Pipeline optimization logic</li>
              <li>Automated EDA processes</li>
              <li>Data quality assessments</li>
              <li>Benchmark datasets</li>
            </ul>
          </div>
        )
      },
      position: { x: 670, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #64B5F6',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Protection Mechanisms
    {
      id: 'protection-mechanisms',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>🔐 Protection Mechanisms</strong>
          </div>
        )
      },
      position: { x: 375, y: 450 },
      style: {
        background: '#e8eaf6',
        border: '2px solid #5C6BC0',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Technical Protection
    {
      id: 'technical-protection',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#4527A0' }}>⚙️ Technical Safeguards</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Code obfuscation & encryption</li>
              <li>Binary compilation of core libs</li>
              <li>API key authentication system</li>
              <li>Request rate limiting</li>
              <li>Secure model serialization</li>
              <li>Watermarked outputs</li>
              <li>Audit trail logging</li>
            </ul>
          </div>
        )
      },
      position: { x: 20, y: 560 },
      style: {
        background: '#ffffff',
        border: '2px solid #9575CD',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Legal Protection
    {
      id: 'legal-protection',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#4527A0' }}>⚖️ Legal Framework</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Software licensing (SaaS/Enterprise)</li>
              <li>Trade secret protection</li>
              <li>Patent applications pending</li>
              <li>Copyright registrations</li>
              <li>Terms of Service enforcement</li>
              <li>Data processing agreements</li>
              <li>Non-compete clauses</li>
            </ul>
          </div>
        )
      },
      position: { x: 330, y: 560 },
      style: {
        background: '#ffffff',
        border: '2px solid #9575CD',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Operational Protection
    {
      id: 'operational-protection',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#4527A0' }}>🏢 Operational Security</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Access control & permissions</li>
              <li>Employee NDAs & IP agreements</li>
              <li>Code review processes</li>
              <li>Secure development practices</li>
              <li>Incident response procedures</li>
              <li>Regular security audits</li>
              <li>Vendor security assessments</li>
            </ul>
          </div>
        )
      },
      position: { x: 640, y: 560 },
      style: {
        background: '#ffffff',
        border: '2px solid #9575CD',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Usage Guidelines
    {
      id: 'usage-guidelines',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>📋 Usage Guidelines</strong>
          </div>
        )
      },
      position: { x: 375, y: 760 },
      style: {
        background: '#e8f5e9',
        border: '2px solid #43A047',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Customer Responsibilities
    {
      id: 'customer-responsibilities',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#2E7D32' }}>👤 Customer Responsibilities</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Protect API credentials</li>
              <li>Comply with usage limits</li>
              <li>Respect licensing terms</li>
              <li>No reverse engineering</li>
              <li>Secure storage of outputs</li>
              <li>Report security incidents</li>
            </ul>
          </div>
        )
      },
      position: { x: 120, y: 870 },
      style: {
        background: '#ffffff',
        border: '2px solid #66BB6A',
        borderRadius: '8px',
        width: 260
      }
    },
    
    // Best Practices
    {
      id: 'best-practices',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#2E7D32' }}>✅ Best Practices</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Regular key rotation</li>
              <li>Monitor usage patterns</li>
              <li>Implement access logging</li>
              <li>Use secure connections</li>
              <li>Follow data governance</li>
              <li>Maintain audit trails</li>
            </ul>
          </div>
        )
      },
      position: { x: 410, y: 870 },
      style: {
        background: '#ffffff',
        border: '2px solid #66BB6A',
        borderRadius: '8px',
        width: 260
      }
    }
  ];

  const edges = [
    {
      id: 'e1-2',
      source: '1',
      target: 'core-tech',
      type: 'smoothstep',
      animated: true,
      style: { stroke: '#2196F3', strokeWidth: 2 }
    },
    {
      id: 'e2-3',
      source: 'core-tech',
      target: 'algorithms',
      type: 'smoothstep'
    },
    {
      id: 'e2-4',
      source: 'core-tech',
      target: 'ml-models',
      type: 'smoothstep'
    },
    {
      id: 'e2-5',
      source: 'core-tech',
      target: 'data-pipeline',
      type: 'smoothstep'
    },
    {
      id: 'e3-6',
      source: 'algorithms',
      target: 'protection-mechanisms',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e4-6',
      source: 'ml-models',
      target: 'protection-mechanisms',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e5-6',
      source: 'data-pipeline',
      target: 'protection-mechanisms',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e6-7',
      source: 'protection-mechanisms',
      target: 'technical-protection',
      type: 'smoothstep'
    },
    {
      id: 'e6-8',
      source: 'protection-mechanisms',
      target: 'legal-protection',
      type: 'smoothstep'
    },
    {
      id: 'e6-9',
      source: 'protection-mechanisms',
      target: 'operational-protection',
      type: 'smoothstep'
    },
    {
      id: 'e7-10',
      source: 'technical-protection',
      target: 'usage-guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e8-10',
      source: 'legal-protection',
      target: 'usage-guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e9-10',
      source: 'operational-protection',
      target: 'usage-guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e10-11',
      source: 'usage-guidelines',
      target: 'customer-responsibilities',
      type: 'smoothstep'
    },
    {
      id: 'e10-12',
      source: 'usage-guidelines',
      target: 'best-practices',
      type: 'smoothstep'
    }
  ];

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <div style={{ 
        background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)', 
        padding: '20px',
        borderBottom: '2px solid #1976D2',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ margin: 0, fontSize: '28px', color: '#1565C0' }}>
          🔬 EvoML Platform - Intellectual Property Protection
        </h1>
        <p style={{ margin: '10px 0 0 0', color: '#666', fontSize: '16px' }}>
          Comprehensive framework for protecting proprietary ML technology and innovations
        </p>
      </div>
      
      <div style={{ width: '100%', height: 'calc(100% - 120px)' }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          fitView
          attributionPosition="bottom-left"
        >
          <Background color="#ddd" gap={20} />
          <Controls />
          <MiniMap 
            style={{
              height: 120,
              backgroundColor: '#f8f8f8',
              border: '1px solid #ddd'
            }}
            maskColor="rgb(50, 50, 50, 0.8)"
          />
        </ReactFlow>
      </div>
    </div>
  );
};

export default EvoMLIntellectualProperty; 